import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

import { ConfigurationService } from '@services/configuration.service';

export interface IReactWidgetParams {
    [key: string]: any;
}

export interface IReactWidgetConfig {
    src: string;
    identifier: string;
}

@Component({
    template: '<div #widget></div>',
})
export abstract class ReactComponent implements OnInit, AfterViewInit {
    @ViewChild('widget') widget;
    @Input() protected abstract params: IReactWidgetParams;

    protected abstract widgetConfig: IReactWidgetConfig;

    public constructor(
        @Inject(DOCUMENT) protected document: Document,
        protected renderer2: Renderer2,
        protected configurationService: ConfigurationService,
    ) {}

    public ngOnInit(): void {
        // @todo move in service ?
        const script = this.renderer2.createElement('script');
        script.type = 'text/javascript';
        script.src = this.widgetConfig.src;
        script.image = '';
        this.renderer2.appendChild(this.document.body, script);
    }

    public ngAfterViewInit(): void {
        const myWidget: HTMLElement = this.renderer2.createElement(this.widgetConfig.identifier);
        const keys = Object.keys(this.params);
        keys.forEach((key) => {
            myWidget.setAttribute(key, this.params[key]);
        });
        this.renderer2.appendChild(this.widget.nativeElement, myWidget);
    }
}
